module.exports = __webpack_public_path__ + "static/img/banner_cprPhoto.86a0404.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_cprPhoto.jpg
// module id = UkYB
// module chunks = 1